var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19231 0.5C3.21305 0.5 2.27389 0.88901 1.58145 1.58145C0.88901 2.27389 0.5 3.21305 0.5 4.19231V12.8077C0.5 13.787 0.88901 14.7261 1.58145 15.4185C2.27389 16.111 3.21305 16.5 4.19231 16.5H12.8077C13.787 16.5 14.7261 16.111 15.4185 15.4185C16.111 14.7261 16.5 13.787 16.5 12.8077V4.19231C16.5 3.21305 16.111 2.27389 15.4185 1.58145C14.7261 0.88901 13.787 0.5 12.8077 0.5H4.19231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.cb55407ea49a5ec6e385fbd93015d582.svg";
export { ForwardRef as ReactComponent };